<div class="lg:px-10 py-8">
  @if (logo) {
    <img
      class="max-w-screen-sm mx-auto lg:w-full h-full object-cover"
      [src]="logo.url"
      alt="Hero image"
    />
  }
</div>
